import joi from 'joi';
import { Record as record } from 'immutable';

import { translate as t } from '../../lib/I18n';
import ValidationMixin from '../ValidationMixin';
import validation from '../../validation';

const defaults = {
    accountNumber: "",
    charity: null,
    method: null,
    paypalEmail: "",
    sortCode: "",
};


class ADRPaymentMethodsForm extends record(defaults) {
    getSchema () {
        return {
            sortCode: joi.any().when('method', {
                is: 'bacs',
                then: joi.string().trim().min(6).max(6).required().messages({
                    'string.base': t('alertmessage.required'),
                    'string.min': t('one-click-delay-repay.paymentMethods.sortCode.length'),
                    'string.max': t('one-click-delay-repay.paymentMethods.sortCode.length'),
                }), otherwise: joi.optional()
            }),
            accountNumber: joi.any().when('method', {
                is: 'bacs',
                then: joi.string().trim().min(8).max(8).required().messages({
                    'string.base': t('alertmessage.required'),
                    'string.min': t('one-click-delay-repay.paymentMethods.accountNumber.length'),
                    'string.max': t('one-click-delay-repay.paymentMethods.accountNumber.length'),
                }), otherwise: joi.optional()
            }),
            paypalEmail: joi.any().when('method', {
                is: 'paypal',
                then: validation.email().messages({
                    'string.base': t('alertmessage.login.badEmail'),
                    'string.email': t('alertmessage.login.badEmail'),
                }), otherwise: joi.optional()
            }),
        };
    }
}

Object.assign(ADRPaymentMethodsForm.prototype, ValidationMixin);

export default ADRPaymentMethodsForm;
